// extracted by mini-css-extract-plugin
export var quillEditor = "_mc-1";
export var variable = "_mc-0";